import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">
            <strong>Effective Date:</strong> October 2025
          </p>
          
          <p className="text-gray-700 mb-6">
            Welcome to Kibouor Foundation, a humanitarian initiative under the AR Holdings Group.
            By accessing our website or making a donation, you agree to the following terms:
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Donations:</h2>
          <p className="text-gray-700 mb-6">
            All public donations go directly to beneficiary programs. Kibouor Foundation is not a financial service provider or investment platform. Donations are non-refundable.
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Transparency:</h2>
          <p className="text-gray-700 mb-6">
            All donation transactions are recorded on Dot Protocol Blockchain for open auditability.
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Sponsorships:</h2>
          <p className="text-gray-700 mb-6">
            Sponsorships for specific homes or individuals are symbolic and pooled for equitable distribution.
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Intellectual Property:</h2>
          <p className="text-gray-700 mb-6">
            All content, logos, and materials are owned by Kibouor Foundation and may not be reused without permission.
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Limitation of Liability:</h2>
          <p className="text-gray-700 mb-6">
            Kibouor Foundation operates in good faith to ensure transparency and proper use of funds but is not liable for indirect damages resulting from website access or use.
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact:</h2>
          <p className="text-gray-700 mb-6">
            For questions or clarifications, contact us at <a href="mailto:support@kibouor.org" className="text-blue-600 hover:underline">support@kibouor.org</a>.
          </p>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-200">
          <a href="/" className="text-blue-600 hover:underline">← Back to Home</a>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
